import { useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import stl from "./AdSection.module.css";
import { useLang } from "@/common/Contexts/LanguageContext";

const AdSection = () => {
  const { t } = useTranslation();
  const lang = useLang();
  const [ShowPopUp, setShowPopUp] = useState(false);
  return (
    <>
      <div className={stl.outterContainer}>
        <hr />
        <div className={stl.container}>
          <h3>
            {t("نجدد سياراتنا ونجهزها حسب الحاجة ", {
              ns: "web_post_view",
            })}
          </h3>
          <div className={stl.imgsContainer}>
            <div>
              <div className={stl.spacer}></div>
              <div className={stl.singleImgContainerAD}>
                <img
                  className={stl.bbAd}
                  src={CDN_LINK + "/assets/images/WashAndPolish.webp"}
                  alt="image"
                  loading="lazy"
                  width={"255px"}
                  height={"298px"}
                />
                {lang === "ar" ? (
                  <img
                    data-dis="ar"
                    className={stl.whiteAd}
                    src={CDN_LINK + "/assets/images/WashAndPolishAr.svg"}
                    alt="image"
                    loading="lazy"
                    width={"148px"}
                    height={"75px"}
                  />
                ) : (
                  <img
                    data-dis="en"
                    className={stl.whiteAd}
                    src={CDN_LINK + "/assets/images/WashAndPolishEn.svg"}
                    alt="image"
                    loading="lazy"
                    width={"148px"}
                    height={"75px"}
                  />
                )}
              </div>
              <div className={stl.singleImgContainerAD}>
                <img
                  className={stl.bbAd}
                  src={CDN_LINK + "/assets/images/PaintInspection.webp"}
                  alt="image"
                  loading="lazy"
                  width={"255px"}
                  height={"298px"}
                />
                {lang === "ar" ? (
                  <img
                    data-dis="ar"
                    className={stl.whiteAd}
                    src={CDN_LINK + "/assets/images/PaintInspectionAr.svg"}
                    alt="image"
                    loading="lazy"
                    width={"148px"}
                    height={"75px"}
                  />
                ) : (
                  <img
                    data-dis="en"
                    className={stl.whiteAd}
                    src={CDN_LINK + "/assets/images/PaintInspectionEn.svg"}
                    alt="image"
                    loading="lazy"
                    width={"148px"}
                    height={"75px"}
                  />
                )}
              </div>
              <div className={stl.singleImgContainerAD}>
                <img
                  className={stl.bbAd}
                  src={CDN_LINK + "/assets/images/PartsReplacement.webp"}
                  alt="image"
                  loading="lazy"
                  width={"255px"}
                  height={"298px"}
                />
                {lang === "ar" ? (
                  <img
                    data-dis="ar"
                    className={stl.whiteAd}
                    src={CDN_LINK + "/assets/images/PartsReplacementAr.svg"}
                    alt="image"
                    loading="lazy"
                    width={"148px"}
                    height={"75px"}
                  />
                ) : (
                  <img
                    data-dis="en"
                    className={stl.whiteAd}
                    src={CDN_LINK + "/assets/images/PartsReplacementEn.svg"}
                    alt="image"
                    loading="lazy"
                    width={"148px"}
                    height={"75px"}
                  />
                )}
              </div>
              <div className={stl.spacer}></div>
            </div>
          </div>
          <div className={stl.btnCont}>
            <span
              onClick={() => {
                setShowPopUp(true);
              }}
            >
              {t("إخلاء مسؤولية", {
                ns: "web_post_view",
              })}
            </span>
          </div>
        </div>
      </div>
      <SharedPopUp
        show={ShowPopUp}
        onClose={() => {
          setShowPopUp(false);
        }}
      >
        <div className={stl.ms2olyenPopUpCR}>
          <strong>
            {t("إخلاء مسؤولية", {
              ns: "web_post_view",
            })}
          </strong>
          <p>
            {t(
              `يستند هذا التقرير إلى حالة السيارة في تاريخ الفحص ويقدم تقديرًا
            تقريبيًا لحالة السيارة في ذلك التاريخ. كانت الأجزاء المذكورة و
            المشار إليها في حالة كما ذكرعنها في التقرير- لا يأخذ التقرير في
            الاعتبار حالة الأجزاء غير المرئية أو غير المفحوصة من السيارة. يعتمد
            نظام الفحص على قراءة عداد السيارة للمسافة بالكيلومترات كما هو ظاهر
            في وقت الفحص وليس مسؤولاً عن التحقق من صحته.`,
              {
                ns: "web_post_view",
              }
            )}
          </p>

          <p>
            {t(
              `لا يعني هذا التقرير بأي حال من الأحوال الالتزام بحالة السيارة كما
              ذكر بالفحص فجميع التقارير تابعة لنظام محدد في فحص السيارات ولا يمكن
              تحميل شركة سيارة وشركائها المسئولية بأي طريقة بسبب استخدام هذا
              التقرير.`,
              {
                ns: "web_post_view",
              }
            )}
          </p>
        </div>
      </SharedPopUp>
    </>
  );
};

export default AdSection;
